'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _UIAlert = require('UIComponents/alert/UIAlert');

var _UIAlert2 = _interopRequireDefault(_UIAlert);

var _Tracking = require('../../constants/Tracking');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MarketingProUpgradeBanner = function MarketingProUpgradeBanner() {
  return _react2.default.createElement(
    'div',
    { className: 'm-bottom-8' },
    _react2.default.createElement(
      _UIAlert2.default,
      {
        type: 'info',
        titleText: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.promotions.marketingProUpgrade.title' }),
        upgradeData: {
          app: _Tracking.APP,
          screen: _Tracking.SUBSCREENS.MARKETING_HUB,
          uniqueId: 'marketing-pro-upgrade-promo',
          upgradeProduct: 'general'
        }
      },
      _react2.default.createElement(
        'p',
        { className: 'm-y-0 m-right-3' },
        _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.promotions.marketingProUpgrade.body' })
      )
    )
  );
};

exports.default = MarketingProUpgradeBanner;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/banners/MarketingProUpgradeBanner.js
// module id = 763
// module chunks = 3 4